function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21951"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "transparent"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17756",
    d: "M7.444 11.111h.009m3.547 0h.009m3.547 0h.009m4.436 0c0 3.927-3.582 7.111-8 7.111a8.767 8.767 0 0 1-3.782-.844L3 18.222l1.24-3.307A6.52 6.52 0 0 1 3 11.111C3 7.184 6.582 4 11 4s8 3.184 8 7.111z",
    transform: "translate(1.5 .5)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  })));
};

export default SvgChat;